var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveCityGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10177_4817)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10177_4817)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0002 0C11.6548 0 5.7002 5.9546 5.7002 13.3C5.7002 20.6454 19.0002 38 19.0002 38C19.0002 38 32.3002 20.6454 32.3002 13.3C32.3002 5.9546 26.3456 0 19.0002 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10177_4817)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9414 14V21.5294H14.7649V14H11.9414ZM13.8238 20.5882H12.8628V18.6861H13.8238V20.5882ZM13.8435 17.7647H12.8638V15.8626H13.8435V17.7647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4119 11.1746V9.29228H19.4708V6.46875H18.5296V9.29228H17.5884V11.1746H15.7061V21.5276H22.2943V11.1746H20.4119ZM17.5884 20.5864H16.6472V18.704H17.5884V20.5864ZM17.5884 17.8024H16.6472V15.8805H17.5884V17.8024ZM17.5884 14.9789H16.6472V13.057H17.5884V14.9789ZM19.4708 20.5864H18.5296V18.704H19.4708V20.5864ZM19.4708 17.8024H18.5296V15.8805H19.4708V17.8024ZM19.4708 14.9789H18.5296V13.057H19.4708V14.9789ZM21.3531 20.5864H20.4119V18.704H21.3531V20.5864ZM21.3531 17.8024H20.4119V15.8805H21.3531V17.8024ZM21.3531 14.9789H20.4119V13.057H21.3531V14.9789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2354 13.0547V21.5253H27.0001V16.8194L23.2354 13.0547ZM25.1469 20.6425H24.1765V19.6128H25.1469V20.6425ZM25.1469 18.7601H24.1765V17.7305H25.1469V18.7601ZM25.1469 16.8777H24.1765V15.8481H25.1469V16.8777Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10177_4817",
    x: 1.7002,
    y: 0,
    width: 34.6001,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10177_4817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10177_4817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10177_4817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10177_4817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveCityGrid);
export default __webpack_public_path__ + "static/media/inactive-city-grid.44276b4c0b57a768a19252f2af79f2fb.svg";
export { ForwardRef as ReactComponent };